import { useCallback, useEffect, useMemo, useState } from "react";
import { useSelector } from "react-redux";
import { useJsApiLoader } from "@react-google-maps/api";
import { useForm } from "react-hook-form";
const GOOGLE_API_KEY = process.env.GOOGLE_API_KEY;
const center = {
    latitude: parseFloat(process.env.LATITUDE),
    longitude: parseFloat(process.env.LONGITUDE),
};
export function useEditAddressState() {
    const { user } = useSelector((state) => state.userState);
    const { isLoaded } = useJsApiLoader({
        id: "google-map-script",
        googleMapsApiKey: GOOGLE_API_KEY,
        libraries: ["places"],
    });
    const [map, setMap] = useState(null);
    const { control, formState: { isValid }, handleSubmit: submitForm, register, setValue, watch, } = useForm({
        defaultValues: {
            full_address: user?.address?.full_address ?? "",
            apartment_number: user?.address?.apartment_number ?? "",
            city: user?.address?.city ?? "",
            notes: "",
            label: user?.address?.label ?? "",
            line_one: user?.address?.line_one ?? "",
            type: user?.address?.type ?? "House",
            postal_code: user?.address?.postal_code ?? "",
            latitude: user?.address?.latitude ?? center?.latitude.toString(),
            longitude: user?.address?.longitude ?? center?.longitude.toString(),
        },
    });
    const type = watch("type");
    const hasErrors = useMemo(() => !isValid, [isValid]);
    const handleLoad = useCallback((map) => {
        setMap(map);
    }, []);
    const handleUnmount = useCallback(function callback(map) {
        setMap(null);
    }, []);
    const handleTypeChanged = useCallback((value) => () => {
        setValue("type", value);
    }, []);
    register("full_address", { required: { value: true, message: "Please provide your Full Address" } });
    register("apartment_number", { required: false });
    register("city", { required: { value: true, message: "Please provide a valid City" } });
    register("notes", { required: false });
    register("line_one", { required: { value: true, message: "Please provide a valid Street Address" } });
    register("label", { required: { value: true, message: "Please provide a friendly label for this Address" } });
    register("type", { required: false });
    register("postal_code", { required: { value: true, message: "Please provide a valid Zip Code" } });
    register("latitude", { required: false });
    register("longitude", { required: false });
    useEffect(() => {
        if (!!map && map?.center) {
            setValue("latitude", map?.center?.lat());
            setValue("longitude", map?.center?.lng());
        }
    }, [map]);
    return useMemo(() => ({
        center,
        control,
        handleLoad,
        handleTypeChanged,
        handleUnmount,
        hasErrors,
        isLoaded,
        submitForm,
        type,
    }), [center, control, handleLoad, handleTypeChanged, handleUnmount, hasErrors, isLoaded, submitForm, type]);
}
